__turbopack_context__.v({
  "badges": "Z68XDG_badges",
  "continue_watching_menu__link": "Z68XDG_continue_watching_menu__link",
  "continue_watching_menu__text": "Z68XDG_continue_watching_menu__text",
  "continue_watching_menu__text_long": "Z68XDG_continue_watching_menu__text_long",
  "continue_watching_menu__wrapper": "Z68XDG_continue_watching_menu__wrapper",
  "continue_watching_menubar__icons": "Z68XDG_continue_watching_menubar__icons",
  "continue_watching_menubar__kabob_icon": "Z68XDG_continue_watching_menubar__kabob_icon",
  "continue_watching_menubar__menu_text": "Z68XDG_continue_watching_menubar__menu_text",
  "continue_watching_menubar__menu_text_long": "Z68XDG_continue_watching_menubar__menu_text_long",
  "continue_watching_menubar__play_icon": "Z68XDG_continue_watching_menubar__play_icon",
  "continue_watching_menubar__text": "Z68XDG_continue_watching_menubar__text",
  "continue_watching_menubar__wrapper": "Z68XDG_continue_watching_menubar__wrapper",
  "continue_watching_show_poster": "Z68XDG_continue_watching_show_poster",
  "continue_watching_show_poster__badge_long_cw": "Z68XDG_continue_watching_show_poster__badge_long_cw",
  "continue_watching_show_poster__badge_my_list": "Z68XDG_continue_watching_show_poster__badge_my_list",
  "continue_watching_show_poster__badge_short_cw": "Z68XDG_continue_watching_show_poster__badge_short_cw",
  "continue_watching_show_poster__fallback": "Z68XDG_continue_watching_show_poster__fallback",
  "continue_watching_show_poster__progress_bar": "Z68XDG_continue_watching_show_poster__progress_bar",
  "continue_watching_show_poster__wrapper": "Z68XDG_continue_watching_show_poster__wrapper",
});
